module.exports = __webpack_public_path__ + "static/media/locatoricon.0257d75e.svg";